












































import Vue from "vue";
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';
import * as AmplifyUI from "@aws-amplify/ui";

export default Vue.extend({

  name: 'AuthForgotPassword',
  data() {
    return {
      code: '',
      password: '',
      error: '',
      sent: false,
      logger: {},
      forgotPwUsername: '',
      emailRules: [
        (v: any) => !!v || 'E-mail is required',
        (v: string) => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      busy: false,
    }
  },
  methods: {
    submit: function () {
      this.busy = true;
      // Pass client meta data as it is used by the backend to customize the message.
      var clientMetadata = {
        "requestFromAddress": window.location.href.split('?')[0]
      };
      Auth.forgotPassword(this.forgotPwUsername, clientMetadata)
        .then(() => {
          this.sent = true;
          this.busy = false;
        })
        .catch(e => {
          this.busy = false;
          this.setError(e)
        });
    },
    verify: function () {
      this.busy = true;
      Auth.forgotPasswordSubmit(this.forgotPwUsername, this.code, this.password)
        .then(() => {
          this.busy = false;
          AmplifyEventBus.$emit('authState', 'signIn');
        })
        .catch(e => {
          this.busy = false;
          this.setError(e)
        });
    },
    signIn: function () {
      AmplifyEventBus.$emit('authState', 'signIn');
    },
    setError: function (e: any) {
      this.error = e.message || e;
    },
  }
});
